import { render, staticRenderFns } from "./CapsTooltip.vue?vue&type=template&id=52c89579&scoped=true"
import script from "./CapsTooltip.vue?vue&type=script&lang=js"
export * from "./CapsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c89579",
  null
  
)

export default component.exports